import { Component, OnInit } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal, ModalDismissReasons, NgbModalConfig, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { ServerService } from '../../../service/server.service'
import { FIND_API_BY_ID_PUBLIC, GET_ALL_API_PUBLIC, LOGIN_MITRA_URL, environment } from 'src/environments/environment';
import { full } from 'src/app/shared/routes/full.routes';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare var require
const Swal = require('sweetalert2')

@Component({
  selector: 'app-documentation-api',
  templateUrl: './documentation-api.component.html',
  styleUrls: ['./documentation-api.component.scss']
})
export class DocumentationApiComponent implements OnInit {

  public show: boolean = false;
  closeResult: string;
  constructor(config: NgbDropdownConfig,
    config1: NgbModalConfig,
    private modalService: NgbModal,
    private server: ServerService,
    public layout:LayoutService,
    private fb: FormBuilder,
    private router: Router,
    private idle: Idle,
    private sanitizer: DomSanitizer,) {
    // customize default values of dropdowns used by this component tree
    config.placement = 'top-left';
    config.autoClose = false;
    config1.backdrop = 'static';
    config1.keyboard = false;

    this.loginForm = fb.group({
      email: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      password: ['',[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]],
      captcha:[null,[Validators.required,Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._ -]+$/)]]
    });
  }

  //row api doc public
  name: String
  desc: String
  rows = []
  rowsData = []
  rowsInfo = []
  rowsVersion = []
  rowsReqHeader = []
  rowsReqBody = []
  rowsResp = []
  jsonReqBody: any
  jsonResp: any
  jsonPathEnvi: any

  reqBodysDetail=[]
  responseBodysDetail=[]

  start: any = 0;
  offset: any = 0;
  limit: any = 10;
  loadingIndicator = false
  count: any = 0

  apiDocUrl =environment.path.base + environment.path.api_doc.base 
  captchaUrl = environment.path.base + environment.path.partner.base + "/user/generate-captcha"

  disable: Boolean 
  captchaId:string;
  public loginForm: FormGroup;
  imageBase64: SafeResourceUrl;

  get l() {
    return this.loginForm.controls
  }


  showPassword() {
    this.show = !this.show;
  }

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    this.loginForm.reset();
    this.server.doGet(this.captchaUrl).subscribe(async resp => {
      this.imageBase64 = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + resp.data.captcha);
      this.captchaId = resp.data.captchaId;
    })
  }

  openLg(content) {
    this.modalService.open(content, { size: 'lg' });
  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngOnInit(): void {
    this.fetchDataNew()
  }

  onClickData(id, data: any) {
    this.getDataApiDocAllEnvi(id);
  }

  private getDataApiDocAllEnvi(pathId){
    this.server.doGet(this.apiDocUrl+'/landing/find-path-by-id/'+pathId).subscribe(async resp => {
      if (resp) {
        this.count = resp.data.recordsFiltered
        // --------SANDBOX----------------
        let rowsPaths=[];
        this.rowsData = []
        this.reqBodysDetail=[]
        this.responseBodysDetail=[]
        rowsPaths.push(resp.data);
        this.loadingIndicator = false;
        rowsPaths.forEach(dataPaths=>{

          // dataPaths.urlSandBox = dataPaths.pathService[0].fullPathRoute
          // dataPaths.urlDevelopment = dataPaths.pathService[0].fullPathRoute.replace("api-sandbox", "api-development")
          // dataPaths.urlProduction = dataPaths.pathService[0].fullPathRoute.replace("api-sandbox", "api-production")
           // const request structure
           const request = dataPaths.requestBody;
           dataPaths.requestBody.filter((response) => response.parentId == null).sort((response1, response2) => (response2.id - response1.id) ).forEach(parent => {
             parent.level = 0;
             parent.childs = 0;
             this.reqBodysDetail.push(parent);
             const childs = request.filter((child) => {
               return child.parentId === parent.id
             }).sort((child1, child2) => (child2.id - child1.id) );
             if (childs.length > 0) {
               this.consChildsRequestBody(childs, parent, request, parent.childs+1,1);
             }
           });

           // const response structure
           const responses = dataPaths.responseBody;
           dataPaths.responseBody.filter((response) => response.parentId == null).sort((response1, response2) =>(response2.id - response1.id) ).forEach(parent => {
             parent.level = 0;
             parent.childs = 0;
             this.responseBodysDetail.push(parent);
             const childs = responses.filter((child) => {
               return child.parentId == parent.id
             }).sort((child1, child2) => (child2.id - child1.id) );
             if (childs.length > 0) {
               this.consChildsResponseBody(childs, parent, responses, parent.childs+1,1);
             }
           });

           dataPaths.respBodyJsonString = JSON.stringify(dataPaths.responseSample, null, 2);
           dataPaths.reqBodyJsonString = JSON.stringify(dataPaths.requestSample, null, 2);
           console.log(dataPaths)
           this.rowsData.push(dataPaths);
        })
      } else {
        Swal.fire('Failure!', resp['message'], 'error');
      }
    });
  }

  fetchDataNew() {
    this.server.doGet(this.apiDocUrl+'/landing/get-list-path').subscribe(async resp => {
      if (resp.data) {
  
        this.count = resp.data.recordsFiltered
        this.rows = []
        this.rows.push(...resp.data);

        this.getDataApiDocAllEnvi( this.rows[0].paths[0].id)
        
      } else {
        Swal.fire('Failure!', resp['message'], 'error');
      }
    });
  }

  fetchData() {
    this.server.doGet(GET_ALL_API_PUBLIC).subscribe(async resp => {
      if (resp) {
        this.count = resp.data.recordsFiltered
        this.rows = []
        this.rows.push(...resp.data)
        this.loadingIndicator = false
        this.rows.forEach(data => {
          let i = 0;
          data.paths.forEach(data2 => {
            data2.respBodyJsonString = JSON.stringify(data2.responseBody, null, 2)
            data2.reqBodyJsonString = JSON.stringify(data2.requestBody, null, 2)
            data2.href = '/mitra/dokumentasi#' + i;
            data2.id = i;
            i++
          })
          console.log('data from apidoc/get-all: ' + data.paths)
        })
        this.getDataApiDocPublic(this.rows[0].id, this.rows[0].paths[0])
        // this.getChilds(this.rows)
        console.log('data dari apidoc: ' + this.rows.toString)
      } else {
        Swal.fire('Failure!', resp['message'], 'error');
      }
    });
  }

  private getDataApiDocPublic(id, data) {
    this.server.doGet(FIND_API_BY_ID_PUBLIC + id).subscribe(async resp => {
      // if (resp) {
      //   var url: any
      //   var fullUrl: any
      //   this.count = resp.data.recordsFiltered
      //   let rowsPaths = []
      //   this.rowsData = []
      //   rowsPaths = resp.data.paths
      //   this.loadingIndicator = false
      //   rowsPaths.forEach(dataPaths => {
      //     if (dataPaths.name == data.name) {
      //       dataPaths.respBodyJsonString = JSON.stringify(dataPaths.responseBody, null, 2)
      //       dataPaths.reqBodyJsonString = JSON.stringify(dataPaths.requestBody, null, 2)
      //       this.rowsData.push(dataPaths)
      //     }

      //     console.log(data.paths)
      //   })
      // } else {
      //   Swal.fire('Failure!', resp['message'], 'error');
      // }

      if (resp) {
        this.count = resp.data.recordsFiltered
        let rowsPaths=[];
        this.rowsData = []
        this.reqBodysDetail=[]
        this.responseBodysDetail=[]
        rowsPaths=resp.data.paths;
        console.log(rowsPaths[0].requestSample);
        this.loadingIndicator = false;
        rowsPaths.forEach(dataPaths=>{
          if(dataPaths.name==data.name){
            let reqBodyJson: any = {};
            let resBodyJson: any = {};
            this.responseBodysDetail=[]

            // const request structure
            const request = dataPaths.requestBody;
            dataPaths.requestBody.filter((response) => response.parentId == null).sort((response1, response2) => (response2.createdDate - response1.createdDate) && (response2.id - response1.id) ).forEach(parent => {
              parent.level = 0;
              parent.childs = 0;
              this.reqBodysDetail.push(parent);
              const childs = request.filter((child) => {
                return child.parentId == parent.id
              }).sort((child1, child2) => (child2.createdDate - child1.createdDate) && (child2.id - child1.id) );
              if (childs.length > 0) {
                this.consChildsRequestBody(childs, parent, request, parent.childs+1,1);
              }
            });

            // const response structure
            const responses = dataPaths.responseBody;
            dataPaths.responseBody.filter((response) => response.parentId == null).sort((response1, response2) => (response2.createdDate - response1.createdDate) && (response2.id - response1.id) ).forEach(parent => {
              parent.level = 0;
              parent.childs = 0;
              this.responseBodysDetail.push(parent);
              const childs = responses.filter((child) => {
                return child.parentId == parent.id
              }).sort((child1, child2) => (child2.createdDate - child1.createdDate) && (child2.id - child1.id) );
              if (childs.length > 0) {
                this.consChildsResponseBody(childs, parent, responses, parent.childs+1,1);
              }
            });

            dataPaths.respBodyJsonString = JSON.stringify(dataPaths.responseSample, null, 2);
            dataPaths.reqBodyJsonString = JSON.stringify(dataPaths.requestSample, null, 2);
            this.rowsData.push(dataPaths);
          }
        })
      } else {
        Swal.fire('Failure!', resp['message'], 'error');
      }
    });
  }

  consChildsRequestBody(childs: any[], parent: any, requests: any[], level: number, idDoc) {
    childs.forEach((child) => {
      const nestedChilds = requests.filter((request) => {
        return request.parent == child.id;
      }).sort((child1, child2) => (child2.createdDate - child1.createdDate) && (child2.id - child1.id) );
      child.level = level;
      child.child = 0;
      this.reqBodysDetail.push(child);
      if (nestedChilds.length > 0) {
        this.consChildsRequestBody(nestedChilds, child, requests, level+1,idDoc);
      }
    });
  }

  consChildsResponseBody(childs: any[], parent: any, responses: any[], level: number, idDoc) {
    childs.forEach((child) => {
      const nestedChilds = responses.filter((response) => {
        return response.parentId == child.id;
      }).sort((child1, child2) => (child2.createdDate - child1.createdDate) && (child2.id - child1.id) );
      child.level = level;
      child.child = 0;
      // if(idDoc==1){
        this.responseBodysDetail.push(child);
      // }else if(idDoc==2){
      //   this.responseBodysDetailDev.push(child);
      // }else{
      //   this.responseBodysDetailProd.push(child);
      // }
      if (nestedChilds.length > 0) {
        this.consChildsResponseBody(nestedChilds, child, responses, level+1,idDoc);
      }
    });
  }

  consLevel(input: number) {
    return new Array(input);
  }

  async copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  roots = []

  getChilds(rows: any) {
    rows.forEach(dt => {
      let i = 0
      dt.paths.forEach(p => {
        p.respBody = JSON.stringify(p.responseBody)
        p.respBody.forEach(rp => {
          if (rp.parentId = null) {
            this.roots = p.respBody
          }
        })
        console.log('root: '+this.roots)
      })
    })
  }

  signIn() {
    this.disable=true
    if (this.loginForm.value.email == "" || this.loginForm.value.password == "") {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Email and password is required.',
      });
      this.disable=false
    } else {
      //login
      this.auth();
    }
  }

  private auth() {
    const loginForm = this.loginForm.value;
    const data = {
      email : loginForm.email,
      password:loginForm.password,
      captchaId:this.captchaId,
      captchaText:loginForm.captcha,
    }
    this.server.doPost(data, LOGIN_MITRA_URL).subscribe(async resp => {
      if (resp) {
        localStorage.setItem('access', '');
        localStorage.setItem('menuInfo', JSON.stringify(resp.data.menus));
        console.log('isi session: ' + localStorage.getItem('menuInfo'));
        localStorage.setItem('grantedInfo', '');
        localStorage.setItem('userInfo', JSON.stringify(resp.data.profile));
        localStorage.setItem('token', resp.token);

        this.router.navigate(['/dashboard/default']);
        this.modalService.dismissAll();

        //Start Session
        this.idle.watch();
      } else {
        Swal.fire('Failure!', resp['message'], 'error');
        this.disable=false
      }
    }, (error) => {
      this.reloadCaptcha()
      this.disable=false
    });  
  }

  reloadCaptcha() {
    this.server.doGet(this.captchaUrl).subscribe(async resp => {
      this.imageBase64 = this.sanitizer.bypassSecurityTrustUrl('data:image/png;base64, ' + resp.data.captcha);
      this.captchaId = resp.data.captchaId;
      this.loginForm.controls.captcha.setValue('');
    })
  }

  

}
